module.exports = __webpack_public_path__ + "e3d71abc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/global/Sidebar/static/ic_Top_Hover.png
// module id = 948
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 16